import Vue from 'vue'

import drRow from '@/components/drRow/index'
Vue.component('dr-row', drRow)

import drColumn from '@/components/drColumn/index'
Vue.component('dr-column', drColumn)

import drTitelBar from '@/components/drTitelBar/index'
Vue.component('dr-title-bar', drTitelBar)

import drTitelBar2 from '@/components/drTitelBar/index2'
Vue.component('dr-title-bar2', drTitelBar2)

import noData from '@/components/noData/index'
Vue.component('dr-nodata', noData)

import infoItem from '@/components/drInfoItem/index'
Vue.component('dr-infoItem', infoItem)

import drListItem from '@/components/drListItem/index'
Vue.component('dr-drListItem', drListItem)

import collection from '@/components/collection/index'
Vue.component('dr-collection', collection)

import share from '@/components/share/index'
Vue.component('dr-share', share)

import shareCommonPage from '@/components/share/shareCommonPage'
Vue.component('dr-shareCommonPage', shareCommonPage)

import VueAliplayer from "@/components/AliPlayer/index";
Vue.component('dr-player', VueAliplayer)

import sliderVertify from "@/components/sliderVertify/index";
Vue.component('dr-sliderVertify', sliderVertify)

import pdf from "@/components/pdf/index";
Vue.component('dr-pdfItem', pdf)

import drTabs from '@/components/drTabs/index'
Vue.component('dr-tabs', drTabs)

import addresTree from '@/components/addresTree/index'
Vue.component('dr-addresTree', addresTree)

import drSeletItem from '@/components/drSeletItem/index'
Vue.component('dr-drSeletItem', drSeletItem)


import drTop from '@/components/drTop/index'
Vue.component('dr-app-top', drTop)

import previewPdfContent from '@/views/my/previewPdfContent'
Vue.component('dr-previewPdfContent', previewPdfContent)


// WEBPACK FOOTER //
// ./src/components/package.js